(function() {
  if (window.__termsCheckboxInit) return;
  window.__termsCheckboxInit = true;

  function findTermsWrap(el) {
    var container = el.closest('.drawer__footer')
      || el.closest('.cart__blocks')
      || el.closest('#main-cart-footer');
    if (container) return container.querySelector('.js-terms-wrap');
    return null;
  }

  function validateTerms(wrap) {
    var checkbox = wrap.querySelector('.js-terms-checkbox');
    if (!checkbox) return true;

    if (checkbox.checked) {
      wrap.classList.remove('has-error');
      return true;
    }

    wrap.classList.add('has-error');
    wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    checkbox.focus();
    return false;
  }

  document.addEventListener('click', function(e) {
    var button = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button) return;

    var wrap = findTermsWrap(button);
    if (wrap && !validateTerms(wrap)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form) return;

    var submitter = e.submitter;
    var isCheckout = submitter && submitter.name === 'checkout';

    if (!isCheckout) {
      var formId = form.id;
      if (formId) {
        submitter = document.querySelector('button[name="checkout"][form="' + formId + '"]');
        isCheckout = !!submitter;
      }
    }

    if (!isCheckout || !submitter) return;

    var wrap = findTermsWrap(submitter);
    if (wrap && !validateTerms(wrap)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('js-terms-checkbox')) return;
    var wrap = e.target.closest('.js-terms-wrap');
    if (wrap && e.target.checked) {
      wrap.classList.remove('has-error');
    }
  }, true);
})();
